import React from "react";
// import styles from "../../assets/scss/PaymentMethodRadio.module.scss"; // File sudah dihapus

const PaymentMethodRadio = (props) => {
  return (
    <>
      <div
        className={`d-flex align-items-center overflow-hidden ${
          props.name === "paymentMethod" && props.label !== "Transfer Bank BCA" && props.label !== "Maybank" && props.label !== "Transfer Bank Mandiri" ? "" : "mb-0"
        }`}
      >
        <input
          type="radio"
          className="form-check-input flex-shrink-0 me-3"
          name={props.name}
          id={props.value}
          value={props.value}
          title={props.label}
          onChange={(e) => props.handler(e)}
          checked={props.data?.label === props.label}
          fee={props.fee ? props.fee : 0}
          add={props.add ? props.add : 0}
          feetype={props.feetype ? props.feetype : ""}
          payment={props.typePayment ? props.typePayment : ""}
        />
        <label
          htmlFor={props.value}
          className="d-flex flex-column text-truncate"
          title={props.label}
        >
          <div className="d-flex align-items-center w-100">
            <div className="payment-icon-container d-flex align-items-center justify-content-center flex-shrink-0 rounded me-3">
              <img 
                src={props.icon} 
                alt={props.value + ".png"} 
                className="img-fluid"
              />
            </div>
            <span className="label-title text-truncate flex-grow-1">{props.label}</span>
          </div>
        </label>
      </div>
      {props.label === "Transfer Bank BCA" && (
        <div className="d-flex align-items-start w-100 payment-description ms-5">
            <div className="bg-light p-3 rounded-3">
              <p className="text-muted small fw-light mb-0 lh-sm">
                Dengan kode unik otomatis, Kode unik akan dikembalikan ke deposit
              </p>
            </div>
        </div>
      )}
      {props.label === "Maybank" && (
        <div className="d-flex align-items-start w-100 payment-description ms-5">
            <div className="bg-light p-3 rounded-3">
              <p className="text-muted small fw-light mb-0 lh-sm">
                Perlu konfirmasi pembayaran manual. Pengecekan dilakukan hanya di hari Senin - Jumat 08.00-17.00 WIB
              </p>
            </div>
        </div>
      )}
      {props.label === "Transfer Bank Mandiri" && (
        <div className="d-flex align-items-start w-100 payment-description ms-5">
            <div className="bg-light p-3 rounded-3">
              <p className="text-muted small fw-light mb-0 lh-sm">
                Perlu konfirmasi pembayaran manual. Pengecekan dilakukan hanya di hari Senin - Jumat 08.00-17.00 WIB
              </p>
            </div>
        </div>
      )}
    </>
  );
};

export default PaymentMethodRadio;
